<template>
  <div style="width:100%; position: relative;
    background-color: rgba(255, 255, 255, 0.5);">

        <div  :style="{width: getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'}">
            <div class="flexSpaceBetween" style="text-align: center;">
                <span class="heading"><h1>{</h1></span><span class="heading" style="top: 50px; position: relative;">Need consultation or want to say hi?</span><span class="heading"><h1>}</h1></span>
            </div>        
        </div>
        <div class="flexSpaceBetween" style="flex-wrap: wrap; width: 70%; margin: 0 auto; text-align: center;">

            <div style="width: 100%; text-align: center; margin-top: 100px;">
                <span>
                    <h2>Email us:</h2>
                    <span>contact@raizzon.com</span>
                    <br><br>
                    <h2>Tel. Number:</h2>
                    <span>+91-674-350-1996</span>
                    <br><br>
                    <h2>Business Address:</h2>
                    <span>
                        Plot No. 9, Industrial Estate, Patia, Bhubaneswar, Odisha, India.
                    </span>
                </span>
            </div>
            
        </div>
        <br><br><br><br><br><br>
  </div>
</template>

<script>
export default {
    computed: {
        getScreenWidth() {
            return window.screen.width
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section7.vue